/** Фото для слайдера клуба — без обложки баннера и без логотипа. */
export function clubGalleryPhotos(source) {
  if (source?.photos?.length) {
    const cover = source.portal_cover_url;
    const logo = source.logo_url;
    return source.photos.filter(
      (url) => url && url !== cover && url !== logo,
    );
  }

  const urls = [];
  const add = (url) => {
    if (url && !urls.includes(url)) urls.push(url);
  };

  for (const url of source?.portal_gallery || source?.gallery || []) {
    add(url);
  }

  return urls;
}
